module.exports = __webpack_public_path__ + "img/danh-gia-khao-sat-icon.9d77af61.svg";